import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "components/SectionHero/SectionHero";

import DemoHomePage from "components/DemoHomePage";
import Header2 from "components/Header/Header2";
import LoactionGridCard from "components/HomeLocationCards/LoactionGridCard";
import LatestBlogPost from "components/LatestBlogPost";
import ReviewSection from "components/ReviewsSection";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import TestimonialCards from "components/Testimonial";
import SectionGridFilterCard2 from "containers/Services/ServiceGridFilterCard";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { fetchEvents } from "redux/features/Admin/Events/eventSlice";
import { fetchFields } from "redux/features/Admin/Fields/fieldSlice";
import { getAllHomeVideos, getHomeDemoVideos } from "redux/features/Admin/homeVideo/homeVideoSlice";
import { getHomeLocations } from "redux/features/location/locationSlice";
import "slick-carousel/slick/slick-theme.css";
import { FrameScreen } from "containers/Screens/FrameScreen";
import OwnerCallToActionImage from "components/CallToAction/OwnerCallToActionImage";

function PageHome() {
  const dispatch = useAppDispatch();

  const eventState = useAppSelector((state) => state.featureEvent);
  const fieldState = useAppSelector((state) => state.featureField);
  const locationState = useAppSelector((state) => state.location?.allLocations);
  const homeVideoStates = useAppSelector((state) => state.videoHome.allVideos);
  useEffect(() => {
    dispatch(getHomeLocations());
    dispatch(fetchEvents());
    dispatch(fetchFields());
    dispatch(getAllHomeVideos());
    dispatch(getHomeDemoVideos());
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Location d’espaces événementiels et salles chez particuliers et professionnels — Paris, Île-de-France et
          partout en France | Event To Bee
        </title>
        <meta
          name="description"
          content="Louez des espaces événementiels et salles chez des particuliers et professionnels, à Paris, en Île-de-France et partout en France. Trouvez le lieu idéal pour tous vos événements."
          title="On simplifie la location de salles à Paris, en Île de France. Trouvez le lieu idéal pour votre événement privé ou professionnel. Réservez facilement sur Event To Bee."
        />
      </Helmet>
      <div className="relative overflow-hidden nc-PageHome">
        <div className="home_class dark:bg-gray-800 ">
          <div className="absolute top-0 left-0 z-0 w-full overflow-hidden" style={{ height: 600 }}>
            <video
              src={homeVideoStates[0]?.url ? process.env.REACT_APP_CLOUD_FRONT + homeVideoStates[0]?.url : ""}
              width={1920}
              autoPlay
              loop
              muted
            ></video>
          </div>

          <div className="container space-y-16 lg:space-y-28">
            <SectionHero />
          </div>
        </div>

        <div className="container relative mb-24 space-y-24 lg:space-y-14 lg:mb-28">
          {/* HOW IT WORK SECTION 1 */}
          <div className="lg:mt-16 xl:mt-36">
            <SectionHowItWork />
          </div>
          <div className="relative py-10">
            <DemoHomePage />
          </div>
          {/* LOCATIONS SECTION */}
          <div className="relative py-10">
            <BackgroundSection />
            <SectionSliderNewCategories
              heading="Découvrez les nouveaux espaces événementiels à louer pour vos événements"
              subHeading="Découvrez les nouveaux lieux disponibles sur Event To Bee : des espaces modernes, élégants ou atypiques, adaptés à tous types d’événements. Mariages, séminaires, soirées d’entreprise, lancements de produit, réunions de travail… trouvez facilement l’espace qui correspond à vos attentes. "
              categoryCardType="card5"
              itemPerRow={5}
              sliderStyle="style2"
              uniqueClassName="ListingStayMapPage"
            />
            <br />
            <div className="pt-16 mt-5">
              <LoactionGridCard data={locationState} />
            </div>
          </div>
          {/* EVENTS SECTION */}
          <div className="relative py-10">
            <SectionSliderNewCategories
              heading="Louer un espace événementiel pour tous types d’événements"
              subHeading="Trouvez facilement le lieu idéal pour chaque occasion : mariage, conférence, team building, réception privée ou événement professionnel. Notre plateforme répertorie des salles de réunion, des espaces de réception, des salles de conférence ou des granges aménagées selon vos besoins. "
              categoryCardType="card5"
              itemPerRow={5}
              sliderStyle="style2"
              uniqueClassName="ListingStayMapPage"
            />

            <div className="relative py-10 pt-16 mt-5">
              <SectionGridFilterCard2 fields={eventState.events} feature={"/espace-evenementiel?event="} />
            </div>
          </div>
          <div>
            <OwnerCallToActionImage
              title="Louez le lieu parfait pour votre événement : entre amis, en famille ou au travail"
              description="Découvrez notre sélection d’espaces événementiels. Que vous cherchiez une salle de réception, un studio, un jardin ou même une péniche, vous trouverez ici le lieu parfait pour tous vos événements, privés ou professionnels"
            />
          </div>{" "}
          {/* SERVICES SECTION */}
          <div className="relative py-10">
            <SectionSliderNewCategories
              heading="Trouvez les meilleurs prestataires événementiels près de chez vous"
              subHeading="La location de salles en Île-de-France n’est pas le seul point noir dans l’organisation d’un événement. L’animation est elle aussi au centre de toutes les préoccupations. Complétez votre événement avec les meilleurs prestataires disponibles en Île-de-France : traiteurs, photographes, décorateurs, animateurs, DJ… Profitez d’un service clé en main pour des réceptions privées, des cocktails dînatoires, des réunions professionnelles ou des mariages inoubliables. "
              categoryCardType="card5"
              itemPerRow={5}
              sliderStyle="style2"
              uniqueClassName="ListingStayMapPage"
            />
            <br />
            <div className="pt-16 mt-5">
              <SectionGridFilterCard2 fields={fieldState.fields} feature={"/prestations?field="} />
            </div>
          </div>
        </div>
        <div className="relative py-10">
          {/* <BackgroundSection /> */}
          <ReviewSection />
        </div>
        <div className="container relative mb-24 space-y-24 lg:space-y-14 lg:mb-28">
          {/* <CallToActionPage /> */}
          <Header2 title={"Devenez Hôte et Proposez Votre Espace !"} url={"/add/location"} />
        </div>
        {/* VIDEO SECTION */}
        {/* <SectionVideos />   */}
        {/* <Header3 />
          <Slider /> */}
      </div>
      <div className="">
        <TestimonialCards title="Ce que disent nos clients sur nos espaces événementiels" />
      </div>
      <div className="pt-12">
        <LatestBlogPost />
      </div>
    </>
  );
}

export default PageHome;
